
import React from 'react';

interface LoadingIndicatorProps {
  message: string;
  className?: string;
}

const LoadingIndicator = ({ message, className }: LoadingIndicatorProps) => {
  return (
    <div className={`flex items-center justify-center p-8 ${className || ''}`}>
      <div className="flex flex-col items-center">
        <div className="h-8 w-8 border-4 border-primary/50 border-t-primary rounded-full animate-spin mb-4"></div>
        <p className="text-muted-foreground">{message}</p>
      </div>
    </div>
  );
};

export default LoadingIndicator;
